<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Daftar Sentra</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagsentra">Daftar Sentra</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Daftar Sentra</h4>
                  <p class="card-title-desc mb-0">Data Sentra Industri Kecil dan Menengah.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagsentra">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">No</th>
                        <th>Nama Sentra</th>
                        <th class="text-center">Jumlah Unit Usaha</th>
                        <th>Kontak Person</th>
                        <th>Lokasi</th>
                        <th>Kapasitas</th>
                        <th>Satuan</th>
                        <th class="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagsentra.data" :key="index">
                        <td scope="row" class="text-center">{{ indagsentra.from + index }}</td>
                        <td scope="row" v-text="row.nama_sentra"></td>
                        <td scope="row" class="text-center" v-text="row.jumlah_unit_usaha"></td>
                        <td scope="row" v-text="row.kontak_person"></td>
                        <td scope="row" v-text="[row.alamat_jalan, row.alamat_desa, row.alamat_kecamatan, row.alamat_kabupaten].filter(r => r).join(', ')"></td>
                        <td scope="row" v-text="row.kapasitas_volume"></td>
                        <td scope="row" v-text="row.kapasitas_satuan || '-'"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagsentra.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Sentra'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row">
              <label for="nama_sentra" class="col-sm-2 col-form-label">Nama Sentra</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nama_sentra" v-model="form.data.nama_sentra">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kontak_person" class="col-sm-2 col-form-label">Kontak Person</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kontak_person"
                  v-model="form.data.kontak_person">
              </div>
            </div>

            <hr>

            <div class="mb-2 row">
              <label for="kabupaten" class="col-sm-2 col-form-label">Kabupaten</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="kabupaten" v-model="form.data.alamat_kabupaten">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kecamatan" class="col-sm-2 col-form-label">Kecamatan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="kecamatan" v-model="form.data.alamat_kecamatan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="desa" class="col-sm-2 col-form-label">Desa</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="desa" v-model="form.data.alamat_desa">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="alamat" class="col-sm-2 col-form-label">Alamat</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="alamat" v-model="form.data.alamat_jalan">
              </div>
            </div>

          </div>

          <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false"
                class="btn btn-outline-success">Ubah</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly && form.id" @click="form.readonly = true"
                class="btn btn-danger">Batal</button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagsentra: Object
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        readonly: true,
        data: {}
      },
    }
  },
  methods: {
    tambah() {
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
    },
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      axios.get('/admin/indagsentra/' + id)
        .then(res => {
          this.form.data = res.data.sentra || {};
        })
    },
    action() {
      const onSuccess = () => {
        this.form.show = false;
        this.form.id = null;
        this.form.data = {};
      }
      if (this.form.id) {
        this.$inertia.put('/admin/indagsentra/' + this.form.id, this.form.data, { onSuccess });
      } else {
        this.$inertia.post('/admin/indagsentra', this.form.data, { onSuccess });
      }
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagsentra/' + row.id);
    }
  },
}
</script>
